import type {CanvasImage} from './canvas-types';
type Run={id:number;skeletonKey?:string|null;input?:{sourceClientId?:string}};
/** Anchor a clone container to its saved source before the first output lands. */
export function cloneFrameSources(images:readonly CanvasImage[],runs:readonly Run[]):Map<number,CanvasImage>{
 const byId=new Map(images.map(image=>[image.id,image]));
 const result=new Map<number,CanvasImage>();
 for(const run of runs){
  if(run.skeletonKey!=='clone-batch')continue;
  const sourceId=run.input?.sourceClientId ?? images.find(image=>image.workflowRunId===run.id&&image.sourceImageId)?.sourceImageId;
  const source=sourceId?byId.get(sourceId):undefined;
  if(source)result.set(run.id,source);
 }
 return result;
}
